import { Component } from 'react'
import { connect } from 'react-redux'
import * as ACT from 'components/proposals/Proposal/actions'
import { ReplaceFileModal } from './ReplaceFileModal'

@connect(() => ({}), null, null, { forwardRef: true })
class ReplaceProposalFileContainer extends Component {
  state = {
    file: null,
    showError: false
  }

  upload = e => {
    const file = e.target.files[0]

    const fr = new FileReader()
    fr.onload = () => {
      this.setState({
        file
      })
    }
    if (file) {
      fr.readAsDataURL(file)
    }
  }

  replaceFile = () => {
    const { proposal, toggleReplaceFileModal, dealId } = this.props
    const { file } = this.state
    if (file) {
      this.props.dispatch({
        type: ACT.PROPOSAL_UPDATE_FILE_REQUESTED,
        payload: {
          proposal,
          file,
          dealId: dealId || proposal.deal.id
        }
      })
      toggleReplaceFileModal()
    } else {
      this.setState({
        showError: true
      })
    }
  }

  render() {
    const { proposal, showReplaceFileModal, toggleReplaceFileModal, isCreate } = this.props
    const { showError } = this.state
    return (
      <ReplaceFileModal
        showReplaceFileModal={showReplaceFileModal}
        toggleReplaceFileModal={toggleReplaceFileModal}
        showError={showError}
        replaceFile={this.replaceFile}
        upload={this.upload}
        proposalName={proposal.name}
        isCreate={isCreate}
      />
    )
  }
}

export default ReplaceProposalFileContainer
